module.exports = __webpack_public_path__ + "img/info_square.d59fdb34.svg";